import { render, staticRenderFns } from "./instituicao.vue?vue&type=template&id=ff7ee79c&"
import script from "./instituicao.vue?vue&type=script&lang=js&"
export * from "./instituicao.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports